module.exports = __webpack_public_path__ + "img/logo-ja-full-color.ef85d2a8.svg";